import Schedules from "./Schedules";
import History from "../../../../Shared/Components/History";
import { Comment } from "../../../../Assembly/TicketModal/comments";

function ScheduleHistory({ticket}: {ticket: any}) {
  return (
    <div className="mx-2 overflow-auto max-h-[720px]">
      <Schedules />
      <History />
      <Comment ticketInfo={ticket} type="checklist" />
    </div>
  );
}

export default ScheduleHistory;
